import {eq} from '@shared/helpers/lang'

import {
    DeliveryManagerType,
    SELECT_ADDRESS_SUBTYPE,
    SELECT_DELIVERY_ADDRESS_SUBTYPE,
    SELECT_DELIVERY_INFO_SUBTYPE,
} from '../constants'

/** 배송지변경창이 리턴해야 하는 데이터 종류 */
export const checkReturnRecords = (type: DeliveryManagerType) => {
    const addressReturnable = Object.keys(SELECT_ADDRESS_SUBTYPE).some(eq(type))
    const deliveryAddressReturnable = Object.keys(SELECT_DELIVERY_ADDRESS_SUBTYPE).some(eq(type))
    const deliveryInfoReturnable = Object.keys(SELECT_DELIVERY_INFO_SUBTYPE).some(eq(type))

    return {
        addressReturnable,
        deliveryAddressReturnable,
        deliveryInfoReturnable,
    }
}
